import { DEFAULT_TOKEN_LIST, type TokenInfo } from "@vapordex/tokenlist";

export const DEFAULT_TOKEN_LOGO_URL =
	"https://static.vapordex.io/0b995621-e23e-42fe-a5d3-36be32cbfd70.jpg";

export const getTokenLogoURL = (token: Partial<TokenInfo>) => {
	if (token?.logoURI) return token?.logoURI;
	const defaultLogoURI = DEFAULT_TOKEN_LIST.tokens.find(
		(_token) => _token.address?.toLowerCase() === token?.address?.toLowerCase(),
	);
	return defaultLogoURI?.logoURI ?? DEFAULT_TOKEN_LOGO_URL;
};
